import React from 'react';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  centered?: boolean;
  className?: string;
}
export function SectionHeading({
  title,
  subtitle,
  centered = false,
  className = ''
}: SectionHeadingProps) {
  return <div className={`mb-10 ${centered ? 'text-center' : ''} ${className}`} data-id="element-548" data-mp="vxjlf97f6u9v">
      <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground mb-3 tracking-tight" data-id="element-549" data-mp="rwq0mop9xvl7">
        {title}
      </h2>
      {subtitle && <p className={`text-muted-foreground text-lg ${centered ? 'max-w-2xl mx-auto' : 'max-w-3xl'}`} data-id="element-550" data-mp="i7y9ujvy9hbv">
          {subtitle}
        </p>}
    </div>;
}